export default __webpack_public_path__ + "static/media/lucky.2b58e6f9.svg";